<template>
  <stormy-file-drop-zone
    class="drop-area data-[active=true]:text-blue-500 flex-1 text-blue-400 !data-[active=true]:font-medium justify-stretch  grid-flow-col h-full border-transparent border-4  data-[active=true]:border-blue-400"
    @files-dropped="addFiles"
  >
    <div class="flex flex-none overflow-hidden px-8 pt-3 text-base font-medium text-gray-500">
      <div class="flex-1 items-center">
        {{ mediaFiles.length }} von {{ totalMediaCount }} Medien im Ordner gefunden

        <span
          v-if="multiple && selectedItems.length"
          class="text-gray-400 font-normal ml-2"
        >
          ({{ selectedItems.length }} ausgewählt)
        </span>
      </div>
      <div class="flex-none w-64 items-center">
        <div class="flex w-full h-4 bg-gray-200 rounded-full overflow-hidden dark:bg-gray-700 hidden">
          <div
            class="flex flex-col justify-center overflow-hidden bg-blue-500 text-xs text-white text-center "
            role="progressbar"
            style="width: 57%"
            aria-valuenow="57"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {{ freeMedia }} / 100 %
          </div>
        </div>
      </div>
    </div>
    <label
      for="file-input"
    >

      <input
        id="file-input"
        class="w-0 h-0"
        type="file"
        multiple
        @change="onInputChange"
      >
    </label>

    <div class="my-0 text-center flex-1 flex flex-col overflow-y-hidden h-full pb-6">
      <div class="overflow-y-auto">
        <MediaGrid
          :files="mediaFiles"
          :uploaded="newMediaFiles"
          :loading="isLoading"
          :multiple="multiple"
        />
      </div>
    </div>
  </stormy-file-drop-zone>
</template>

<script setup>
// Components

// File Management
import useFileList from '@/composables/useFileList.js'
import createUploader from '@/composables/useFileUploader.js'
import { useProp } from '@/composables/useProp.js'
import MediaGrid from './MediaGrid.vue'
import { useMediaStore } from '@/pinia/MediaStore'
import { storeToRefs } from 'pinia'
import { computed, watch } from 'vue'

const mediaStore = useMediaStore()
const { mediaFiles, isLoading, newMediaFiles, selectedItems, totalMediaCount } = storeToRefs(mediaStore)

const props = defineProps({
  folder: useProp(String),
  parent: useProp(String),
  parentId: useProp(Number),
  multiple: useProp(Boolean, false)
})

const { files, addFiles } = useFileList()

const freeMedia = computed(() => Math.round(100 - (totalMediaCount.value / 250 * 100)))

watch(files, async (files) => {
  await uploadFiles(files)
})

function onInputChange (e) {
  console.log(e.target.files)
  uploadFiles(e.target.files)
  e.target.value = null // reset so that selecting the same file again will still cause it to fire this change
}
const { uploadFiles } = createUploader(props.parent, props.parentId)

</script>
